import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Link, BrowserRouter as Router, Switch } from 'react-router-dom';
import './index.css';
import App from './App';
import CodeWith from './components/codewith/codewith';
import Resume from './components/resume/resume';
import Notfound from './components/notfound/notfound'

import * as serviceWorker from './serviceWorker';

const routing = (
  <Router>
    <div>
      <Switch>
	      <Route exact path="/" component={Resume} />
	      <Route component={Notfound} />
      </Switch>
    </div>
  </Router>
)

ReactDOM.render(routing, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
